import React, { useState } from "react";
import { Alert, Box, Tab, Tabs, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import TemplatesTab from "./components/TemplatesTab";
import TenantRulesTab from "./components/TenantRulesTab";
import AdminConfigsTab from "./components/AdminConfigsTab";
import ProviderConfigsTab from "./components/ProviderConfigsTab";
import PayoutRulesTab from "./components/PayoutRulesTab";
import DispatchLogsTab from "./components/DispatchLogsTab";
import ProcessTriggersTab from "./components/ProcessTriggersTab";

const TABS = [
  { value: "templates", label: "Templates" },
  { value: "rules", label: "Tenant Rules" },
  { value: "adminConfigs", label: "Admin Configs" },
  { value: "providers", label: "Providers" },
  { value: "payoutRules", label: "Payout Rules" },
  { value: "dispatches", label: "Dispatch Logs" },
  { value: "process", label: "Process Triggers" },
];

const Notifications = () => {
  const roleFromState = useSelector((state) => state.role);
  const isAdminFlag = useSelector((state) => state.isAdmin);
  const role = roleFromState || (isAdminFlag === 1 ? "admin" : "manager");
  const [activeTab, setActiveTab] = useState("templates");

  if (role !== "admin") {
    return (
      <Box m={2}>
        <Alert severity="warning">Only admins can access notification configuration.</Alert>
      </Box>
    );
  }

  return (
    <Box m="20px">
      <Typography variant="h4" sx={{ mb: 2 }}>
        Notifications
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Configure tenant reminders, payout alerts, channels, templates, rules, recipients, and schedules.
      </Typography>

      <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
        <Tabs
          value={activeTab}
          onChange={(_, value) => setActiveTab(value)}
          variant="scrollable"
          scrollButtons="auto"
        >
          {TABS.map((tab) => (
            <Tab key={tab.value} value={tab.value} label={tab.label} />
          ))}
        </Tabs>
      </Box>

      {activeTab === "templates" && <TemplatesTab />}
      {activeTab === "rules" && <TenantRulesTab />}
      {activeTab === "adminConfigs" && <AdminConfigsTab />}
      {activeTab === "providers" && <ProviderConfigsTab />}
      {activeTab === "payoutRules" && <PayoutRulesTab />}
      {activeTab === "dispatches" && <DispatchLogsTab />}
      {activeTab === "process" && <ProcessTriggersTab />}
    </Box>
  );
};

export default Notifications;
